<template>
  <span class="phone-column">{{ formattedValue }}</span>
</template>

<script setup lang="ts">
import {computed} from 'vue';

import {formatCulturePhoneNumber} from '@/use/formatCultureValue';

const props = defineProps<{
  value?: string | null,
}>();

const formattedValue = computed(() => formatCulturePhoneNumber(props.value));
</script>
